module.exports = __webpack_public_path__ + "img/ig_a.3ea922b.svg";